import type { TypeChatChannel } from '@/types/conversation/types.conversation.chat.channel';

export function chatUnreadTotal(channels: readonly TypeChatChannel[], now: number = Date.now()): { total: number; mentions: number } {
    let total = 0;
    let mentions = 0;
    for (const channel of channels) {
        const count = channel.unread?.count ?? 0;
        const mentioned = channel.unread?.mentionIds.length ?? 0;
        if (!count) continue;
        mentions += mentioned;
        const muted = Boolean(channel.mutedUntil && new Date(channel.mutedUntil).getTime() > now);
        total += muted || channel.archivedAt ? Math.min(mentioned, count) : count;
    }
    return { total, mentions };
}

export default chatUnreadTotal;
